<template lang="pug">
.page
  .max-width
    .row
      .col.max
        router-view
      .col
        aside
          .aside-header
            span Account Settings
          nav
            .aside-label.primary-text You
            hr
            router-link(:to="{ name: 'SettingsAccount' }") Account
            router-link(:to="{ name: 'SettingsChangePassword' }") Change Password

            .aside-label.primary-text Company
            hr
            router-link(:to="{ name: 'SettingsCompany' }") General
            router-link(:to="{ name: 'SettingsTeam' }") Team
            router-link(:to="{ name: 'SettingsStatuses' }") Statuses
            router-link(:to="{ name: 'SettingsBilling' }") Billing

            .aside-label.primary-text Integrations
            hr
            router-link(:to="{ name: 'SettingsCustomDomain' }") Custom Domain
            router-link(:to="{ name: 'SettingsSlack' }") Slack
            router-link(:to="{ name: 'SettingsIntercom' }") Intercom
</template>

<script>

import { mapState } from 'vuex'

export default {
  name: 'SettingsLayout',
  beforeMount () {
    this.$store.dispatch('getPlans')
  },
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
  }
}
</script>

<style lang="stylus" scoped>
  nav
    font-size $text-size-small
    .aside-label
      font-weight 600
      padding $spacing-2 $spacing-2
    a
      color $text-light
      display block
      padding $spacing-2
      &.router-link-exact-active
        background-color $background-active
        color $text-default
    hr
      border none
      border-top $border-default
      margin 0
  aside
    border $border-default
    border-radius $border-radius
    margin-bottom $spacing-3
    margin-left $spacing-3
    width 370px
    .aside-header
      background-color $background-color
      padding $spacing-4 0
      margin-bottom $spacing-2
      text-align center

</style>
